import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.css']
})
export class ServiceComponent implements OnInit {
  imagesUrl = environment.imagesUrl;

  titleSectionProp: any = {
    title: 'למה דווקא אנחנו?',
    description: ''
  };

  List: any[] = [
    {
      title: 'חדשנות',
      image: this.imagesUrl + 'why-us-icon/95.png',
      desc: 'המסכים שלנו נבנו בטכנולוגיה חדישה שמאפשרת שליטה מרחוק ועוד המון יכולות מדהימות',
      color:'#E5F6FD'
    },
    {
      title: 'שירות אישי ומקצועי',
      image: this.imagesUrl + 'why-us-icon/service-icon-frame.png',
      desc: 'חברתנו שמה דגש על שירות איכותי וטיפול אישי בכל לקוח',
      color:'#F5EFFD'
    },
    {
      title: 'דינמיות ויעילות',
      image: this.imagesUrl + 'why-us-icon/dynamic-icon-frame.png',
      desc: 'בלחיצת כפתור המודעה שלך נכנסת למסך בלי דאגות וללא המתנה מיותרת',
      color:'#E6FCF5'
    },
    {
      title: 'עיצוב ע"י מומחי UI & UX',
      image: this.imagesUrl + 'why-us-icon/design-icon-frame.png',
      desc: 'המסך שלנו מורכב מאלמנטים נבחרים שמגרים את העין לצפיה בו ולמשיכת הקהל',
      color:'#FDF7EB'
    },
    {
      title: 'התקנה נוחה ומהירה',
      image: this.imagesUrl + 'why-us-icon/click-icon-frame.png',
      desc: 'בעזרת חיבור מהיר של מכשיר הסטרימר שלנו ישירות אל המסך שלכם, תוכלו להתחיל להשתמש בשירות בקלות ובמהירות',
      color:'#FFF0EE'
    }
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
